import React from "react";

function UserAddedSuccessIcon() {
  return (
    <svg
      width="87"
      height="87"
      viewBox="0 0 87 87"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle
        cx="43.2347"
        cy="43.2347"
        r="43.2347"
        fill="#39B260"
        fillOpacity="0.19"
      />
    </svg>
  );
}

export default UserAddedSuccessIcon;
